import React from 'react';
import {
  ICohortRefFieldsFragment,
  IFilterFieldsFragment,
} from '../../../utils/apollo/graphqlSchema';
import * as BuilderInfoUI from '../BuilderInfoUI';
import FilterInfo from './FilterInfo';
import { MeasureFilterDisplayValues } from '../../Builder/ReportFilter/MeasureFilter';
import { IMeasureFilterValue } from '../../../redux/slices/oldBuilder';
import { IndexedIcon } from '../../Icon';

interface IProps {
  filter: IFilterFieldsFragment | null;
  name?: string;
  measureFilterValues?: IMeasureFilterValue[];
  globalCohorts?: ICohortRefFieldsFragment[];
}

export default ({ filter, measureFilterValues, globalCohorts }: IProps) => (
  <BuilderInfoUI.VerticalNestedRow>
    <BuilderInfoUI.HorizontalRow>
      <BuilderInfoUI.HighlightedLabel>
        Global Filter
      </BuilderInfoUI.HighlightedLabel>
      {globalCohorts && globalCohorts?.length > 0 && (
        <>
          {globalCohorts.map((_, index) => (
            <BuilderInfoUI.IconContainer key={`global-filter-cohort-${index}`}>
              <IndexedIcon
                name="named-cohort"
                positiveIndex={index + 1}
                isActive={true}
              />
            </BuilderInfoUI.IconContainer>
          ))}
        </>
      )}
    </BuilderInfoUI.HorizontalRow>
    {filter && <FilterInfo filter={filter} />}
    {measureFilterValues && measureFilterValues?.length > 0 && (
      <MeasureFilterDisplayValues measureFilterValues={measureFilterValues} />
    )}
  </BuilderInfoUI.VerticalNestedRow>
);
